import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/tea"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66674 1.25263L4.70712 0.292969L3.29288 1.70715L4.25249 2.66681L5.66674 1.25263ZM5.66674 1.25263C6.44774 2.03367 6.44774 3.29994 5.66674 4.08099L5.41418 4.33355L6.37379 5.29321L4.95954 6.70739L3.99993 5.74773C3.21893 4.96669 3.21893 3.70041 3.99993 2.91937L4.25249 2.66681L5.66674 1.25263ZM13 9.00017H12V10.5V11.0002H13C13.5523 11.0002 14 10.5525 14 10.0002C14 9.44788 13.5523 9.00017 13 9.00017ZM11.4002 13.0002H12H13C14.6569 13.0002 16 11.657 16 10.0002C16 8.34331 14.6569 7.00017 13 7.00017H12V7.00008H1V8V9.00008V10.5C1 13.5376 3.46243 16 6.5 16C8.63728 16 10.4898 14.7809 11.4002 13.0002ZM8.04046 0.292969L9.00007 1.25263L7.58582 2.66681L6.62621 1.70715L8.04046 0.292969ZM9.00007 1.25263L7.58582 2.66681L7.33326 2.91937C6.55226 3.70041 6.55226 4.96669 7.33326 5.74773L8.29288 6.70739L9.70712 5.29321L8.74751 4.33355L9.00007 4.08099C9.78107 3.29994 9.78107 2.03367 9.00007 1.25263Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Tea16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Tea16 = createIcon(IconComponent);